<div
    class="sidebar-area bg-white box-shadow"
    [ngClass]="{ active: isToggled }"
    [class.dark-sidebar]="themeService.isSidebarDark()"
    [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()"
>
    <div class="logo bg-white">
        <a routerLink="/" class="d-flex align-items-center">
            <img src="assets/img/logo.png" alt="logo" />
        </a>
    </div>
    <div
        class="burger-menu"
        (click)="toggle()"
        [ngClass]="{ active: isToggled }"
    >
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
    </div>
    <ng-scrollbar visibility="hover" style="height: 100vh">
        <div class="sidebar-inner">
            <div class="sidebar-menu">
                <mat-accordion>
                    <a
                        routerLink="/"
                        class="sidebar-menu-link"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                    >
                        <i class="flaticon-menu-2"></i>
                        <span class="title">Dashboard</span>
                    </a>
                </mat-accordion>
                <mat-accordion>
                    <a
                        routerLink="/models"
                        class="sidebar-menu-link"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                    >
                        <i class="flaticon-chart"></i>
                        <span class="title">Planificador</span>
                    </a>
                </mat-accordion>
            </div>
        </div>
    </ng-scrollbar>
</div>
